var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OuterCasing',{attrs:{"isScroll":_vm.isScroll}},[_c('LoadingComponents'),_c('keep-alive',{attrs:{"include":"DetailRedirect,Detail"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }